import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage, stats } from '../data/copy';
export function Hero() {
  return <header className="w-full bg-ink" data-id="element-86" data-mp="9k0gndfbepsa">
      <div className="mx-auto max-w-4xl px-6 pb-10 pt-8 text-center sm:pt-10" data-id="element-87" data-mp="9l33na9io82x">
        <Pill tone="gold" data-id="element-88" data-mp="4n1ov1j4iux9">Para entrenadores de atletismo</Pill>

        

        <h1 className="mx-auto mt-4 max-w-3xl font-display text-[1.75rem] font-bold leading-[1.1] text-ivory sm:text-[2.75rem] lg:text-[3.4rem]" data-id="element-89" data-mp="129qudld1bpnv">
          Planifica todo tu entrenamiento en{' '}
          <span className="text-gold" data-id="element-90" data-mp="sai4p4p7cx7b">5 minutos</span>
        </h1>

        {/* El mockup va inmediatamente debajo de la promesa (el titular). */}
        <div className="relative mt-7" data-id="element-91" data-mp="nbydopvr4v83">
          <div className="absolute inset-x-0 bottom-8 top-10 rounded-4xl bg-coal" aria-hidden="true" data-id="element-92" data-mp="3d21rzwjzqin7" />
          <img src={heroImage} alt="El Megapack Atletismo 360 completo: estuche, 6 volúmenes técnicos y 5 bonos impresos." className="relative mx-auto w-full max-w-sm sm:max-w-xl lg:max-w-2xl" width={1240} height={1240} decoding="sync" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-93" data-mp="381xkgw128y94" />
        </div>

        <p className="mx-auto mt-4 max-w-readable font-sans text-sm leading-relaxed text-stone sm:text-base" data-id="element-94" data-mp="399ba3kjqp7ue">
          El sistema completo para entrenadores de atletismo en español: 6
          volúmenes técnicos, +70 sesiones listas para usar y 5 bonos
          exclusivos.
        </p>

        <div className="mt-7" data-id="element-95" data-mp="358zq89z7bbjz">
          <CtaButton href="#oferta" size="large" className="w-full sm:w-auto" data-id="element-96" data-mp="35aat87ktofa1">
            Acceso completo ahora
          </CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-97" data-mp="2viokchvyisag">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-stone sm:text-xs" data-id="element-98" data-mp="2hjf2zew0ls4w">
              <CheckIcon className="h-3.5 w-3.5 text-gold" strokeWidth={2.6} aria-hidden="true" data-id="element-99" data-mp="2ll0dwuoznwcg" />
              {badge}
            </li>)}
        </ul>
      </div>

      <div className="border-y border-line bg-coal" data-id="element-100" data-mp="s3ur9xru3ab5">
        <dl className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-line px-6" data-id="element-101" data-mp="na9xyj16r4ia">
          {stats.map(stat => <div key={stat.label} className="px-3 py-7 text-center" data-id="element-102" data-mp="id050tel8app">
              <dd className="font-display text-4xl font-bold leading-none text-gold sm:text-5xl" data-id="element-103" data-mp="ddnf1zsf6niw">
                {stat.value}
              </dd>
              <dt className="mt-2 font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-stone sm:text-xs" data-id="element-104" data-mp="1b04cd515l14n">
                {stat.label}
              </dt>
            </div>)}
        </dl>
      </div>
    </header>;
}